import { gkApi } from './index';

const contingentApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listContingents: builder.query({
      query: ({ eventId, destinationId, article, destinationType } = {}) => ({
        url: '/contingent/',
        method: 'get',
        params: {
          event_id: eventId,
          destination_id: destinationId,
          article,
          destination_type: destinationType,
          limit: 1000,
        },
      }),
      providesTags: [{ type: 'CONTINGENT_LIST' }],
    }),
    createContingent: builder.mutation({
      query: (payload) => ({
        url: '/contingent/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: [
        { type: 'CONTINGENT_LIST' },
        { type: 'CONTINGENT_STATUS' },
      ],
    }),
    updateContingent: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/contingent/${id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [
        { type: 'CONTINGENT_LIST' },
        { type: 'CONTINGENT_STATUS' },
      ],
    }),
    deleteContingent: builder.mutation({
      query: (id) => ({ url: `/contingent/${id}/`, method: 'delete' }),
      invalidatesTags: [
        { type: 'CONTINGENT_LIST' },
        { type: 'CONTINGENT_STATUS' },
      ],
    }),
    getContingentStatus: builder.query({
      query: ({ eventId, destinationIds } = {}) => {
        const params = new URLSearchParams();
        if (eventId) params.append('event_id', eventId);
        (destinationIds || []).forEach((d) =>
          params.append('destination_ids', d)
        );
        return {
          url: `/crew-delivery/contingents/?${params.toString()}`,
          method: 'get',
        };
      },
      providesTags: [{ type: 'CONTINGENT_STATUS' }],
    }),
  }),
});

export const {
  useListContingentsQuery,
  useCreateContingentMutation,
  useUpdateContingentMutation,
  useDeleteContingentMutation,
  useGetContingentStatusQuery,
} = contingentApi;
